import { SVGProps, FC } from 'react'

interface IProps extends SVGProps<SVGSVGElement> {}

const TwoUser: FC<IProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 36 36"
      fill="none"
      stroke="currentColor"
      {...props}
    >
      <path
        d="M13.7398 16.305C13.5898 16.29 13.4098 16.29 13.2448 16.305C9.67484 16.185 6.83984 13.26 6.83984 9.66C6.83984 5.985 9.80984 3 13.4998 3C17.1748 3 20.1598 5.985 20.1598 9.66C20.1448 13.26 17.3098 16.185 13.7398 16.305Z"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.6149 6C27.5249 6 29.8649 8.355 29.8649 11.25C29.8649 14.085 27.6149 16.395 24.8099 16.5C24.6899 16.485 24.5549 16.485 24.4199 16.5"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.24008 21.84C2.61008 24.27 2.61008 28.23 6.24008 30.645C10.3651 33.405 17.1301 33.405 21.2551 30.645C24.8851 28.215 24.8851 24.255 21.2551 21.84C17.1451 19.095 10.3801 19.095 6.24008 21.84Z"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.5098 30C28.5898 29.775 29.6098 29.34 30.4498 28.695C32.7898 26.94 32.7898 24.045 30.4498 22.29C29.6248 21.66 28.6198 21.24 27.5548 21"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default TwoUser
